import React, { useEffect, memo, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './HotSearch.module.less';
import { getHotSearch, getHotSearchApp } from '../actions/search';
import { CONTEXT } from '../config';
import { setSearchKeyWord, setHotLenovoVisible } from '../actions/layout';
import SoftCardSearchHot from '../components/SoftCardSearchHot/SoftCardSearchHot';
import { logPostInfo, logging } from '../actions/log';
import { sortSoftsByLocalSoftInit } from '../utils/utils';

const selectHotSearch = createSelector(
  state => state.search,
  search => search.hotSearch,
);

const selectHotSearchApp = createSelector(
  state => state.search,
  search => search.hotSearchApp,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(() => {
  const dispatch = useDispatch();
  const hotSearchData = useSelector(selectHotSearch);
  const hotSearchAppData = useSelector(selectHotSearchApp);
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const [showSofts, setShowSofts] = useState([]);

  useEffect(() => {
    if (hotSearchData.length === 0) {
      dispatch(getHotSearch());
    }
  }, [dispatch, hotSearchData]);

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: `Search_Hot`,
        label: '',
        param2: {
          source: logInfoData.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (!hotSearchAppData.apps) {
      dispatch(getHotSearchApp());
    } else {
      const showSoftArr = sortSoftsByLocalSoftInit(hotSearchAppData.apps || [], localSoftsInit);
      setShowSofts(showSoftArr);
    }
  }, [dispatch, hotSearchAppData]);

  // 1. 联系词softcard 做特殊处理 (即：将其作为搜索结果点击进入详情处理)
  // 首位应用进入详情页面的时候，重置两次logPostInfo（即：让source，source_p，source_p后移一步，logInfo.source = 'Search'）
  // 详情页中通过source_p==='Search'判断来源是否来自搜索
  const handleSoft = useCallback(
    soft => {
      // search_type 1: 热词    2: 联想词   3: 搜索词   4: 联想词 首位应用   5: 热词  首位应用
      dispatch(
        logPostInfo({
          source: 'Search',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
          search_word: soft.softName,
          search_type: 5,
        }),
      );
    },
    [dispatch],
  );

  const handleSelectKw = useCallback(
    keyWord => {
      dispatch(setSearchKeyWord(keyWord));
      dispatch(setHotLenovoVisible(-1));
      // search_type 1: 热词    2: 联想词   3: 搜索词
      dispatch(
        logPostInfo({
          source: 'Search',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
          search_word: keyWord,
          search_type: 1,
        }),
      );
      // 新搜索时页面滚动到顶部
      document.getElementById('container_content').scrollTo(0, 0);
    },
    [dispatch],
  );

  const handleStopProp = useCallback(ev => {
    ev.stopPropagation();
  }, []);

  return showSofts.length > 2 || hotSearchData.length > 8 ? (
    <div
      className={styles.popus}
      onClick={handleStopProp}
      onMouseDown={handleStopProp}
      onTouchStart={handleStopProp}
    >
      <div className="title">今日热搜</div>
      {showSofts.length > 0 && (
        <div className="list_app">
          {showSofts.slice(0, 2).map((v, i) => (
            <div
              key={i}
              className="list_item"
              onClick={() => {
                handleSoft(v);
              }}
            >
              <SoftCardSearchHot
                soft={v}
                // 联系词softcard 做特殊处理  （card里面的事件先执行）  参数通过父组件传入
                // 首位应用进入详情页面的时候，重置两次logPostInfo（即：让source，source_p，source_p后移一步，logInfo.source = 'Search'）
                // 详情页中通过source_p==='Search'判断来源是否来自搜索
                logInfo={{
                  isSearch: true,
                  source: 'Search',
                  source_p: logInfoData.source,
                  source_pp: logInfoData.source_p,
                  search_type: 5,
                }}
              />
            </div>
          ))}
        </div>
      )}
      <div className="list">
        {hotSearchData.length > 8 &&
          hotSearchData.slice(0, 8).map(v => (
            <Link
              key={v.id}
              onClick={() => {
                handleSelectKw(v.word);
              }}
              to={`${CONTEXT}/search/soft?keyword=${encodeURIComponent(v.word)}`}
            >
              {v.word}
            </Link>
          ))}
      </div>
    </div>
  ) : (
    ''
  );
});
